import store from './store';
import axios from 'axios';

store.subscribe((mutation)=>{
    switch(mutation.type)
     {
         case 'auth/SET_TOKEN':
             if(mutation.payload)
             {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + mutation.payload;
              localStorage.setItem('token' , mutation.payload);
              // on check user is has token and Authoriz   # // get cart info if user login 
              // store.dispatch('get_data_cartAction');
            //    store.dispatch('get_setting_api');
            
             }
             else{
                 axios.defaults.headers.common['Authorization'] = null;
                 localStorage.removeItem('token');
             }
         break;
     }     
 })
// store.registerModule((getters)=>{
// console.log("gettersoomar" , getters);
// });

